import React from 'react';
import './scss/export-plotheader.scss';
import ExportPlotBar from './ExportPlotBar';
import { ConfigurationBarPoint } from 'models/interfaces/configurationExport/export';
interface ExportPlotHeaderProps {
  points: number;
  pointsData: ConfigurationBarPoint[];
}
const ExportPlotHeader = ({ points, pointsData, ...props }: ExportPlotHeaderProps) => {
  return (
    <div className="program-header">
      <div className="program-header__content-wrapper">
        <img
          src="https://cdn.thomasnet.com/img/thomas-verified-supplier-shield.png"
          alt=""
          className="mr-1"
        />
        <div className="program-header__content" id="program-block">
          <h2 className="program-header__title">Thomas Verified Program</h2>
          <p className="program-header__subTitle">Points Configuration Summary</p>
        </div>
      </div>
      <div className="program-header__content-wrapper" id="points-block">
        <div className="program-header__content text-center mr-1">
          <h2 className="program-header__title">{points}</h2>
          <p className="program-header__subTitle">Total Points</p>
        </div>
        <div className="program-header__content">
          <ExportPlotBar data={pointsData} />
          <div className="bar-msg">
            Points allocated to regional coverage areas are included in Total Points but are not
            reflected in the bar graph above.
          </div>
        </div>
      </div>
    </div>
  );
};

ExportPlotHeader.defaultProps = {
  points: 0,
  pointsData: []
};

export default ExportPlotHeader;
